module.exports = __webpack_public_path__ + "img/rengzheng.d005d188.png";